module.exports = __webpack_public_path__ + "static/konabikesland-cc8c9b65fabb12a496ba9cb6246e9260.jpg";